module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("发货")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "已选择设备"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', _vm._l((_vm.row.choosed), function(i) {
            return _c('p', {
              key: i
            }, [_vm._v(_vm._s(i))])
          }), 0)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleChoose(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("选择设备")])
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), (_vm.row.isAlipayMini && _vm.row.dispalyExtra) ? _c('section', {
    staticClass: "installment"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._v("\n                 分期数：" + _vm._s(_vm.hasInstallmentCount) + " / " + _vm._s(_vm.installmentCount) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._v("\n                租金：" + _vm._s((_vm.hasInstallmentCount * _vm.row.dispalyExtra.paidData.rental / _vm.installmentCount).toFixed(2)) + " / " + _vm._s(_vm.row.dispalyExtra.paidData.rental) + "\n            ")]), _vm._v(" "), (!_vm.canInstallment && !_vm.installmentDone) ? _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("今日已扣款，请明日执行")]) : _vm._e(), _vm._v(" "), (_vm.installmentDone) ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("扣款完成，可以发货")]) : _vm._e(), _vm._v(" "), (!_vm.installmentDone) ? _c('el-button', {
    attrs: {
      "disabled": !_vm.canInstallment,
      "type": "primary"
    },
    on: {
      "click": _vm.doInstallment
    }
  }, [_vm._v("扣款")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.row
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件人：",
      "label-width": "100px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.receiverName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "100px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.receiverTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址：",
      "label-width": "100px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.addressDetail.province + ' ' + _vm.row.addressDetail.city + ' ' + _vm.row.addressDetail.district + ' ' + _vm.row.addressDetail.fullAddress))])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.sendForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运送方式",
      "label-width": "100px",
      "prop": "description"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.wayValue),
      callback: function($$v) {
        _vm.wayValue = $$v
      },
      expression: "wayValue"
    }
  }, _vm._l((_vm.waysArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.wayValue === 'express') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "快递公司",
      "label-width": "100px",
      "prop": "description"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sendForm.shipper),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "shipper", $$v)
      },
      expression: "sendForm.shipper"
    }
  }, _vm._l((_vm.expressArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "快递单号",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.expressNumber),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "expressNumber", $$v)
      },
      expression: "sendForm.expressNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货人",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "operator", $$v)
      },
      expression: "sendForm.operator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("发货")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.wayValue === 'self') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "快递单号",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.expressNumber),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "expressNumber", $$v)
      },
      expression: "sendForm.expressNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货人",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sendForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.sendForm, "operator", $$v)
      },
      expression: "sendForm.operator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("发货")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.nickName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.username))])]), _vm._v(" "), (_vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy.length) ? _c('el-form-item', {
    attrs: {
      "label": "租赁时间：",
      "label-width": "180px"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].begin)))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.rentDay) + "天")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.row && _vm.row.dispalyExtra && _vm.row.dispalyExtra.tenancy) ? _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v(_vm._s(_vm.fromatDate(_vm.row.dispalyExtra.tenancy[0].end)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "租金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.rental))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "优惠券抵扣(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.discount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "押金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.deposit))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "减免押金(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paidData.depositDiscount))])]) : _vm._e(), _vm._v(" "), (_vm.row.dispalyExtra) ? _c('el-form-item', {
    attrs: {
      "label": "费用统计(单位：元)：",
      "label-width": "180px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.row.dispalyExtra.paymount))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加设备",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择仓库",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.storageChange
    },
    model: {
      value: (_vm.storage),
      callback: function($$v) {
        _vm.storage = $$v
      },
      expression: "storage"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.storageName))])])
  }), 1)], 1), _vm._v(" "), (_vm.storage) ? _c('el-form-item', {
    attrs: {
      "label": "选择设备",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.deviceId,
        "value": item.productId
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.deviceId))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("序列号")])])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sureNow
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e00dcd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/SendExpress.vue
// module id = 726
// module chunks = 1